<template>
    <div class="sc-message--text">
        <p v-html="messageText" />
        <p v-if="data.meta" :style="{ color: messageColors.color }" class="sc-message--meta">
            {{ data.meta }}
        </p>
    </div>
</template>

<script>
import Autolinker from 'autolinker';
import { htmlEscape } from 'escape-goat';
import fmt from 'msgdown';

export default {
    props: {
        data: {
            type: Object,
            required: true,
        },
        messageColors: {
            type: Object,
            required: true,
        },
        messageStyling: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        messageText() {
            const escaped = htmlEscape(this.data.text);

            return Autolinker.link(this.messageStyling ? fmt(escaped) : escaped, {
                className: 'chatLink',
                truncate: { length: 50, location: 'smart' },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
a.chatLink {
    color: inherit !important;
}
</style>
